<template>
  <section class="pa-times-flash-line">
    <div class="flash-line">
      <div class="flash-line-box">
        <div class="title-field" :class="additionalTitleClass">
          <TokeiTimesLogo @click.prevent="handleClickTimesLogo" />
          <div class="notification-badge" v-if="hasUnreadedInfomation"><div class="circle">●</div></div>
        </div>
        <div class="flash-line-field" ref="flashLineField">
          <div ref="lineText" class="line-text" :class="lineTextClass"><span ref="flashLineText" v-html="flashMessage"></span></div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import TokeiTimesLogo from '@/components/Parts/GlobalHeaderForLoginedView/TimesFlashLine/images/tokei_times.svg?inlineN'

import {GetInfomation, GetInfomationList} from '@/graphql/queries/Infomation.graphql'

export default {
  components : {
    TokeiTimesLogo
  },

  data(){
    return {
      flashLineIntervalId     : null,
      
      flashLineIndent         : 0,
      
      lineTextClass           : [],
      
      flashMessage            : 'これはサンプルのメッセージです。',
      
      flashLineIntervalSpeed  : (1000/60),
      
      flashLineLoopCounter    : 0,

      messageOffsetWidth      : 0,

      additionalTitleClass    : {
        'has-unread'  : false
      }
    };
  },

  computed : {
    mountedLayoutStyleName(){
      return this.$store.state.layouts.mountedLayoutStyleName;
    },

    currentLine(){
      return this.$store.state.timesFlashLine.currentLine;
    },

    messageManager(){
      return this.$store.state.timesFlashLine.messageManager;
    },

    loopManager(){
      return this.$store.state.timesFlashLine.loopManager;
    },

    hasQueuedMessageOnLoopManager(){
      if(this.loopManager.length > 1){
        return true;
      }else{
        return false;
      }
    },

    hasMessageOnMessageManager(){
      if(this.messageManager.length === 0){
        return false;
      }else{
        return true;
      }
    },

    shouldEndLoopMessage(){
      if(this.hasMessageOnMessageManager && this.currentLine === 'loop'){
        return true;
      }else{
        return false;
      }
    },

    flashLineObject(){
      return this.$store.state.timesFlashLine.flashLineObject;
    },

    hasUnreadedInfomation(){
      return this.$store.state.paTimesModal.hasUnreadedInfomation;
    }
  },

  apollo : {
    // 未読メッセージの確認フラグ用に読み込みます。
    infomations : {
      query : GetInfomationList,
      
      variables(){
        return {
          first   : this.first,
          page    :  this.page,
          orderBy : [
            {
              // field : 'id',
              column : 'id',
              order : 'DESC'
            }
          ]
        }
      },

      result({data: {infomations: {data}}}){

        const apolloClient = this.$apollo.provider.defaultClient;

        for(let infomation of data){
          apolloClient.writeQuery({
            query     : GetInfomation,
            variables : {
              id  : infomation.id
            },
            data      : {
              infomation : infomation
            }
          });
        }
      },
      
      error(err){
        const simpleErrorSet = this.getApolloSimpleErrorFromApolloError(err);
        
        this.apolloResultValidation(simpleErrorSet);
      },

      pollInterval: (1000 * 30),
    }
  },

  watch : {
    flashLineObject : {
      handler(data){
        if(typeof data === 'undefined') return;
        if(data === null) return;
        
        this.updateFlashLine(data);
      },
      immediate: true,
      deep: true
    },

    mountedLayoutStyleName : {
      handler(value){
        if(value === null) return;

        // console.log(value);
        // if(value === 'home'){
        //   this.testIntialize();
        // }

        // this.initializeFlashLine();
      },
      immediate: true
    },

    infomations : {
      handler(data){
        if(typeof data === 'undefined') return;

        this.checkHasUnReadInfomation(data);
      },
      immediate: true
    },

    hasUnreadedInfomation : {
      handler(value){
        if(typeof value === 'undefined') return;
        
        this.additionalTitleClass['has-unread'] = value;

        if(value === true){
          this.$nextTick(() => {
            this.setInfomationAlertFlashLine();
          });
        }
      },
      immediate: true
    }
  },

  methods : {
    setInfomationAlertFlashLine(){
      let unreadInfomationData = null;

      for(let infomation of this.infomations.data){
        if((infomation.characterReaded === false) && (infomation.send_type !== 'global')){
          unreadInfomationData = infomation;
          break;
        }
      }

      if(unreadInfomationData === null) return;

      const dateJPString = this.$options.filters.mutateFlashLineDate(unreadInfomationData.created_at);
      
      this.$store.dispatch({
        type  : 'timesFlashLine/pushFlashMessage',
        line  : 'message',
        data  : [
          {
            type    : 'alert',
            message : '【特別通知事項発生】',
            loop    : false, // trueの場合は無限、数字指定で回数、falseで１回
          },
          {
            type    : 'flash',
            message : '異世界地球日本時間'+dateJPString+'、'+unreadInfomationData.body+'詳しい情報は塔経瞬時より御確かめください。',
            loop    : false, // trueの場合は無限、数字指定で回数、falseで１回
          }
        ],
      }, {root:true});
    },

    requestNextFlashMessage(){
      // this.clearFlashMessageEvent();

      this.$store.dispatch({
        type  : 'timesFlashLine/requestNextObject'
      }, {root:true});
    },

    nextFlashMessageValidation(){
      if(this.flashLineObject.loop === true){
        return true;
      }else if (this.flashLineObject.loop === false){
        return false;
      }else{
        if(this.flashLineObject.loop === this.flashLineLoopCounter){
          return false;
        }else{
          return true;
        }
      }
    },
    
    updateFlashLine(data){
      this.flashMessage = data.message;

      switch(data.type){
        case 'flash':
          this.$nextTick(() => {
            this.clearFlashMessageEvent();

            this.$refs.lineText.style.textIndent = this.$refs.flashLineField.offsetWidth+'px';

            this.lineTextClass = ['line-text-active'];
            this.initializeFlashLineInterval();
          });
        break;
        
        case 'alert':
          this.clearFlashMessageEvent();

          this.initializeAlertAnimation();
          this.lineTextClass = ['line-text-active', 'line-text-as-alert'];
        break;
      }
    },

    clearFlashMessageEvent(){
      if(typeof this.$refs.lineText !== 'undefined'){
        this.$refs.lineText.style.textIndent = 0;
      }

      this.flashLineLoopCounter = 0;
      this.lineTextClass = [];
      this.clearExistsIntervals();
    },

    alertAnimationEndEvent(){
      this.$refs.lineText.removeEventListener('animationend', this.alertAnimationEndEvent);
      this.lineTextClass = [];
      
      this.flashLineLoopCounter++;

      if(this.nextFlashMessageValidation()){
        setTimeout(() => {
          this.initializeAlertAnimation();
          this.lineTextClass = ['line-text-active', 'line-text-as-alert'];
        }, 100);
      }else{
        this.requestNextFlashMessage();
      }
    },

    initializeAlertAnimation(){
      this.$refs.lineText.addEventListener('animationend',    this.alertAnimationEndEvent);
    },
    
    flashLineInterval(){
      this.flashLineIndent--;

      this.$refs.lineText.style.textIndent = this.flashLineIndent+'px';
      
      // １度流し終わったらvalidationに飛ばします。
      if (this.flashLineIndent < (-1 * this.$refs.flashLineText.offsetWidth)) {
        this.flashLineLoopCounter++;
        
        if( this.nextFlashMessageValidation() && !this.shouldEndLoopMessage && !this.hasQueuedMessageOnLoopManager ){
          this.flashLineIndent = this.$refs.flashLineField.offsetWidth;
        }else{
          this.requestNextFlashMessage();
        }
      }
    },

    initializeFlashLineInterval(){
      if(this.flashLineIntervalId !== null) return;

      // 文字のインデントに横幅を設定します。
      this.flashLineIndent = this.$refs.flashLineField.offsetWidth;
      
      this.flashLineIntervalId = setInterval(this.flashLineInterval, this.flashLineIntervalSpeed);
    },

    clearExistsIntervals(){
      if(this.flashLineIntervalId !== null){
        clearInterval(this.flashLineIntervalId);
        this.flashLineIntervalId = null;
      }
    },

    initializeFlashLine(){
      this.requestNextFlashMessage();
    },

    // testIntialize(){
    //   this.requestNextFlashMessage();

    //   setTimeout(() => {
    //     this.$store.dispatch({
    //       type  : 'timesFlashLine/pushFlashMessage',
    //       line  : 'message',
    //       data  : [
    //         {
    //           type    : 'alert',
    //           message : '！！！緊急情報！！！',
    //           loop    : false, // trueの場合は無限、数字指定で回数、falseで１回
    //         },
    //         {
    //           type    : 'flash',
    //           message : 'これは緊急情報です。',
    //           loop    : false, // trueの場合は無限、数字指定で回数、falseで１回
    //         }
    //       ],
    //     }, {root:true});
    //   }, 5000);

    //   setTimeout(() => {
    //     this.$store.dispatch({
    //       type  : 'timesFlashLine/pushFlashMessage',
    //       line  : 'loop',
    //       data  :       {
    //         type    : 'flash',
    //         message : 'これは更新したメッセージです。',
    //         loop    : true, // trueの場合は無限、数字指定で回数、falseで１回
    //       }
    //     });
    //   }, 20000);
    // }

    handleClickTimesLogo(){
      const newUrlQuery = Object.assign({}, this.$route.query);

      newUrlQuery['times_modal_open'] = 'yes';
      newUrlQuery['y']                = window.scrollY;

      this.$router.push({
        name    : this.$route.name,
        params  : this.$route.params,
        query   : newUrlQuery
      });
    },

    checkHasUnReadInfomation(data){
      let hasUnreadedInfomation = false;

      for(let infomation of data.data){
        if(infomation.characterReaded === false){
          hasUnreadedInfomation = true;
          break;
        }
      }

      this.$store.dispatch({
        type  : 'paTimesModal/updateHasUnreadedInfomation',
        value : hasUnreadedInfomation
      });
    },
  },
  
  beforeDestroy(){
    // console.log('call flash line destroy');
    this.clearFlashMessageEvent();
  },

  mounted(){
    this.$parent.$parent.$on('mountedPage', () => {
      // console.log('call mounted page');
      this.initializeFlashLine();
    });
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";
@import "@/assets/scss/_variables.scss";

@keyframes keyframe-fade
{
  0%   {
    opacity:.7;
  }

  50% {
    opacity:1;
  }

  100% {
    opacity:.7;
  }
}

@keyframes keyframe-blink {
  0% {opacity:0;}
  50% {opacity:1;}
  100% {opacity:0;}
}

.pa-times-flash-line{
  font-family: "游明朝", YuMincho, "YuKyo_Yoko-Medium", "ヒラギノ明朝 ProN W3", "Hiragino Mincho ProN", "HG明朝E", "ＭＳ Ｐ明朝", "ＭＳ 明朝", serif;
  background:#540E23;
  padding:2vw 0;
  font-weight: bold;

  @include from($desktop) {
    padding:4px 0;
  }

  .flash-line{
    display: flex;
    flex-direction: row;

    width:97%;
    height:34px;
    margin:0 auto;
    line-height: 1;

    background-color: #993D59;
    border:3px solid #771E39;

    @include from($desktop) {
      box-sizing: border-box;
      width:100%;
      height:auto;
      border-width: 4px;
    }
    
    .flash-line-box{
      display: flex;
      width:100%;

      .title-field{
        width:20%;
        height:100%;
        line-height:100%;
        margin:0 auto;
        padding:0 0 0 3px;
        user-select: none;
        background-color: #993D59;
        display: flex;
        align-items: center;
        position: relative;

        .notification-badge{
          box-sizing: border-box;
          width:9px;
          height:9px;
          border-radius: 4.5px;
          background-color:#993D59;
          position: absolute;
          top:3px;
          right:3px;
          font-size:8px;
          margin:0;
          text-align: center;
          vertical-align: middle;
          display:flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          
          div.circle{
            margin-top:1px;
            margin-left:1px;
            color:#771E39;
            color:#6b1a32;
          }
        }

        @include from(768px) {
          width:10%;
        }

        @include from($desktop) {
          width:20%;
        }

        .helper{
          display: inline-block;
          height: 100%;
          vertical-align: middle;
        }

        svg{
          opacity:.7;
          vertical-align: middle;
          cursor: pointer;

          width:100%;
          height:auto;
          
          &:active{
            opacity: .7;
          }
        }

        &.has-unread{
          svg{
            animation: keyframe-fade 3s infinite;
            animation-timing-function:ease-in-out;
          }
        }
      }

      .flash-line-field{
        color: #540E23;
        margin-top:-1px;
        line-height:normal;
        height: 100%;
        width:80%;
        vertical-align: middle;
        position: relative;
        overflow:hidden;
        white-space:no-wrap;
        user-select: none;

        @include from(768px) {
          width:90%;
        }

        @include from($desktop) {
          width:80%;
        }

        .line-text{
          white-space:nowrap;
          width:auto;
          font-size:22px;
          opacity:0;

          &-active{
            opacity:1;
          }

          &-as-alert{
            opacity: 0;
            animation-name: keyframe-blink;
            animation-duration: .8s;
            animation-iteration-count: 2;

            text-align: center;
          }

          &-visible{
            display: inline;
          }

          span{
            margin:0;
            padding:0;
            vertical-align: middle;
          }
        }
      }

      @include from($desktop) {
        .title-field{
          width:15%;
        }

        .flash-line-field{
          width:85%;
        }
      }
    }
  }
}
</style>